// Common styles for Material UI and dashboard elements

import FuseTheme from '../global/theme';

export const commonStyles = {

    dash: {flex: {display: 'flex'}},
    dashContainer: {position: 'relative', marginRight: '1em'},
    dashTitle: {width: 'calc(100% - 180px)', boxSizing: 'border-box'},
    divider: {
        display: 'block',
        width: '100%',
        height: 1,
        backgroundColor: FuseTheme.palette.primary1Color,
        border: 'none',
        margin: '1em 0 0.5em 0'
    },

    error: {fontSize: 16, color: FuseTheme.palette.errorColor},
    hidden: {display: 'none', opacity: 0},

    marginBottom: {marginBottom: '2em'},
    marginRight: {marginRight: '1em'},
    mt0: {marginTop: 0},
    mt1: {marginTop: '1em'},
    mt2: {marginTop: '2em'},
    mb0: {marginBottom: 0},
    mb1: {marginBottom: '1em'},
    mb2: {marginBottom: '2em'},
    ml0: {marginLeft: 0},
    marginTop: {marginTop: '1em'},

    headerButton: {
        display: 'inline-block',
        color: '#ffffff',
        margin: '0 10px 0 0',
    },
    headerButtonIcon: {
        display: 'inline-block',
        color: '#ffffff',
        margin: '0 6px 0 8px',
        verticalAlign: 'middle',
    },
    headerButtonLink: {
        display: 'inline-block',
        fontWeight: 500,
        color: '#ffffff',
        textTransform: 'uppercase',
        textDecoration: 'none',
        margin: '0 12px 0 0'
    },

    loaderContainer: {textAlign: 'center', margin: '1em auto 1em auto'},
    loaderContainerLeft: {display: 'block', textAlign: 'left', margin: '1em 0 1em 1em'},
    loader: {
        display: 'inline-block',
        margin: '0 0 0 8px',
        verticalAlign: 'middle',
    },

    summaryIcon: {
        fill: '#f5f5f5',
        width: 36,
        height: 36,
        margin: '0 10px 0 0',
        verticalAlign: 'middle'
    },
    summaryIconSmall: {
        fill: '#f5f5f5',
        width: 30,
        height: 30,
        margin: '0 8px 0 0',
        verticalAlign: 'middle'
    },
    buttonContainer: {display: 'flex'},
    buttonContainerWithMessage: {display: 'flex', flexDirection: 'column', alignItems: 'flex-end'},
    buttonInline: {display: 'inline-block', marginRight: '1em'},
    buttonInlineRight: {display: 'inline-block', marginLeft: '1em'},
    buttonRaised: {color: '#1478b9'},
    buttonErrorMessage: {fontSize: 14, margin: '5px 0 0 0'},

    tableDetail: {lineHeight: '1.3', margin: '10px 0 2px 0', padding: '0 0 0 46px'},
    textLink: {
        color: '#1478b9',
        textDecoration: 'none',
        borderBottom: '1px dotted rgba(33,33,33,0.5)',
    },
};



// WEBPACK FOOTER //
// ./src/Fuse/shared/styles.js